import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=18a60a1e&scoped=true"
import script from "./countDown.vue?vue&type=script&lang=js"
export * from "./countDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a60a1e",
  null
  
)

export default component.exports